<template>
    <div class="slide-show">
        <div class="slide-holder" :style="{marginLeft:-100*current+'%', opacity, width: (all_slides.length*100)+'%'}" :class="{animated}">
            <div v-for="(slide,idx) in all_slides" class="slide" :class="{active:idx === current, ['align-'+slide.align]:slide.align}" :style="{backgroundImage:`url(${slide.image}?w=3200)`, width:(100/all_slides.length)+'%'}">
                <div class="fader" :style="styles.fade">
                    <div class="content">
                        <div class="title" v-if="slide.title" :style="styles.title">{{slide.title[lang]}}</div><br />
                        <div class="subtitle" v-if="slide.subtitle" :style="styles.title">{{slide.subtitle[lang]}}</div> <br />
                        <!-- <div class="action-button" v-if="slide.action" @click="action(slide.action.name)">{{slide.action.label}}</div> -->
                        <div class="action-button" v-if="slide.btn_label&&slide.btn_label[lang]" @click="openAction(slide.url)">{{slide.btn_label[lang]}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="controls">
            <div class="prev-btn" @click="prev()" @mouseout="startAutoplay()">
                <span class="fal fa-angle-left"></span>
            </div>
            <div class="next-btn" @click="next()" @mouseout="startAutoplay()">
                <span class="fal fa-angle-right"></span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        "slides": { type: Array },
        "autoplay": { type: Number, default: 10000 },
        "styles": {
            type: Object,
            default () {
                return {
                    fade: { background: "rgba(0,0,0,0.25)" }
                }
            }
        }
    },
    mounted() {
        this.all_slides = this.slides;
        if (this.autoplay) {
            this.startAutoplay();
        }
    },
    watch: {
        slides(nw, ol) {
            let self = this;
            console.log(ol, nw)
            this.animated = false;
            this.opacity = 0;
            self.stopAutoplay();
            setTimeout(() => {
                self.current = 0;
                setTimeout(() => {
                    self.startAutoplay();
                    self.opacity = 1;
                    setTimeout(() => {
                        self.animated = true;
                    }, 200);
                }, 200);
                self.all_slides = nw;
            }, 200);
            this.$forceUpdate();
        }
    },
    name: 'i-slide-show',
    methods: {
        openAction(url) {
            window.open(url);
        },
        openDetails() {

        },
        startAutoplay() {
            console.log("Start autoplay")
            this.stopAutoplay();
            this.autoplayTimer = setInterval(() => {
                this._next();
            }, this.autoplay)
        },
        stopAutoplay() {
            if (this.autoplayTimer) {
                clearInterval(this.autoplayTimer);
            }
        },
        action(actionName) {
            this.$emit('input', actionName);
        },
        prev() {
            this.stopAutoplay();
            this._prev()
        },
        _prev() {
            this.current = this.current - 1;
            if (this.current < 0) {
                this.current = this.all_slides.length - 1;
            }
        },
        next() {
            this.stopAutoplay();
            this._next()
        },
        _next() {
            this.current = this.current + 1;
            if (this.current >= this.all_slides.length) {
                this.current = 0;
            }
        },
    },
    data() {
        return {
            showDetails: false,
            opacity: 1,
            animated: true,
            current: 0,
            autoplayTimer: false,
            all_slides: []
        }
    }
}
</script>
<style lang="css" scoped>
.slide-show {
    height: 400px;
    overflow: hidden;
}

.slide {
    background-size: cover;
    height: 400px;
    background-position: center;
    width: 12.5%;
    float: left;
}


.slide-holder {
    white-space: nowrap;
    transition: 0.2s opacity ease-in-out;
}

.slide-holder.animated {
    transition: 0.7s margin ease-in-out;
}

.next-btn,
.prev-btn {
    padding: 16px 16px;
    font-size: 64px;
    color: white;
    display: inline-block;
    cursor: pointer;
    margin-top: 170px;
    display: none;
}

.next-btn:hover,
.prev-btn:hover {
    background: rgba(0, 0, 0, 0.2);



}

.next-btn {
    float: right;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
}

.prev-btn {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;

}

.controls {
    height: 400px;
    position: relative;
    display: block;
    width: 100%;
    top: -100%;
    z-index: 9;
}

.fader {
    height: 400px;
    background: rgba(0, 0, 0, 0.25);
    display: table;
    width: 100%;
    transition: 0.3s all ease;
}

.slide .content {
    vertical-align: middle;
    text-align: center;
    color: white;
    height: 400px;
    display: table-cell;
    width: 100%;
    white-space: normal;
    padding: 100px 15%;
    text-transform: uppercase;
    background: rgba(0, 0, 0, 0.22)
}

.slide.align-top .content {
    vertical-align: top;
}

.slide.align-bottom .content {
    vertical-align: bottom;
}

.title,
.subtitle {
    display: inline-block;
    color: white;
    background: rgba(0, 0, 0, 0.55);
    padding: 4px 12px;
    margin: 2px;
    border-radius: 4px;
    transition: 0.3s all ease;
}


.slide .content,
.fader,
.slide,
.slide-show {
    height: 280px
}

.next-btn,
.prev-btn {
    margin-top: 100px;
}

.title {
    font-size: 22px;
}

.subtitle {
    font-size: 14px;
}

@keyframes move-left {
    0% {
        transform: translate(-2000px, 0);
        opacity: 0;
    }

    100% {
        transform: translate(0, 0);
        opacity: 1;
    }
}

@keyframes move-right {
    0% {
        transform: translate(2000px, 0);
        opacity: 0;
    }

    100% {
        transform: translate(0, 0);
        opacity: 1;
    }
}

@keyframes move-top {
    0% {
        transform: translate(0, -2000px);
        opacity: 0;
    }

    100% {
        transform: translate(0, 0);
        opacity: 1;
    }
}

@keyframes move-bottom {
    0% {
        transform: translate(0, 2000px);
        opacity: 0;
    }

    100% {
        transform: translate(0, 0);
        opacity: 1;
    }
}

@keyframes zoom-in {
    0% {
        background-size: 110% auto;
    }

    100% {
        background-size: 130% auto;
    }
}

@keyframes zoom-out {
    0% {
        background-size: 130% auto;
    }

    100% {
        background-size: 110% auto;
    }
}

.slide.active .title {
    animation: move-right 1s 1 ease-in-out;
}

.slide.active .subtitle {
    animation: move-left 1s 1 ease-in-out;
}

.slide.active .action-button {
    animation: move-bottom 1s 1 ease-in-out;
}

.slide {
    background-size: cover;
}

.slide.active {
    animation: none;
}

.action-button {
    border: 1px solid black;
    display: inline-block;
    padding: 6px 12px;
    background: rgba(255, 255, 255, 0.6);
    color: black;
    border-radius: 4px;
    margin: 8px 0;
    cursor: pointer;
    display: none;
}

.action-button:hover {
    background: rgba(255, 255, 255, 1);
}





@media (min-width: 576px) {

    .slide .content,
    .fader,
    .slide,
    .slide-show {
        height: 400px;
    }

    .title {
        font-size: 32px;
    }

    .subtitle {
        font-size: 16px;
    }

    .next-btn,
    .prev-btn {
        margin-top: 150px;
    }

    .slide {}

    .slide.active {}


    .next-btn,
    .prev-btn {
        display: inline-block;
    }

    .action-button {
        display: inline-block;
    }

    .details {
        display: none;
    }
}

@media (min-width: 768px) {

    .slide .content,
    .fader,
    .slide,
    .slide-show {
        height: 400px;
    }

    .title {
        font-size: 42px;
    }

    .subtitle {
        font-size: 24px;
    }


}

@media (min-width: 992px) {

    .slide .content,
    .fader,
    .slide,
    .slide-show {
        height: 400px;
    }
}

@media (min-width: 1200px) {

    .slide .content,
    .fader,
    .slide,
    .slide-show {
        height: 600px;
    }

    .next-btn,
    .prev-btn {
        margin-top: 250px;
    }
}
</style>